import React, { ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { FormComponent, UiComponent } from 'components';
import { USER_MENU_URL } from 'data/menu';
import { tableToolbar, tableWrap } from 'styles/table';
import {
  IPageOption,
  IUserGroupListItem,
  SearchUserGroupFilterType,
} from 'types';
import * as UserGroupStyle from '../style';

const USER_GROUP_URL = USER_MENU_URL['회원 그룹 관리'];

const COLS: string[] = ['그룹명', '회원 수', '생성자', '생성일'];

interface Props {
  pageOption: IPageOption;
  handlePage: (option: IPageOption) => void;
  data: IUserGroupListItem[];
  totalPage: number;
  handleFilter: (filter: SearchUserGroupFilterType) => void;
}

function List({ data, handleFilter, ...pageOptions }: Props) {
  const navigate = useNavigate();

  const renderer: Record<
    (typeof COLS)[number],
    (data: IUserGroupListItem & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      그룹명: ({ id, name }: IUserGroupListItem) => (
        <p
          css={UserGroupStyle.link}
          onClick={() => navigate(`${USER_GROUP_URL}/${id}`)}
        >
          {name}
        </p>
      ),
      '회원 수': ({ memberCount }: IUserGroupListItem) => (
        <>{memberCount.toLocaleString('ko')}명</>
      ),
      생성자: ({ createdBy }: IUserGroupListItem) => <>{createdBy ?? '-'}</>,
      생성일: ({ createdAt }: IUserGroupListItem) => (
        <>{dayjs(createdAt).format('YYYY-MM-DD')}</>
      ),
    }),
    [],
  );

  const rows = data.map((g) => ({ ...g, rowKey: g.id }));

  return (
    <UiComponent.Box>
      <div css={tableToolbar}>
        <FormComponent.Form
          submit={(d: SearchUserGroupFilterType) =>
            handleFilter({ name: d.name?.trim() || undefined })
          }
        >
          <FormComponent.SearchInput
            name="name"
            placeholder="그룹명으로 검색해주세요"
          />
        </FormComponent.Form>
        <UiComponent.Button
          variant="contained"
          color="primary"
          onClick={() => navigate(`${USER_GROUP_URL}/register`)}
        >
          그룹 만들기
        </UiComponent.Button>
      </div>
      <div css={tableWrap}>
        <UiComponent.Table
          cols={COLS}
          renderer={renderer}
          data={rows}
          sticky
          empty="등록된 회원 그룹이 없습니다"
        />
      </div>
      <UiComponent.Pagination {...pageOptions} />
    </UiComponent.Box>
  );
}

export default List;
